module.exports = __webpack_public_path__ + "img/velo_publicitaire5.4b127441.jpg";